import React from 'react';
import './style.css';
import carousel1 from '../../assets/carousel/Jenni & Patrick -1-2.jpg';
import carousel2 from '../../assets/carousel/Jenni & Patrick -2.jpg';
import carousel3 from '../../assets/carousel/Jenni & Patrick -3-2.jpg';
import carousel4 from '../../assets/carousel/Jenni & Patrick - Verlobungsshooting -39.jpg';
import carousel5 from '../../assets/carousel/Jenni & Patrick - Verlobungsshooting -89.jpg';
import carousel6 from '../../assets/carousel/Jenni & Patrick - Verlobungsshooting -116.jpg';
import carousel7 from '../../assets/carousel/Jenni & Patrick - Verlobungsshooting -119.jpg';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export class WeddingCarousel extends React.Component {
    render() {
        return (
            <div id="carousel-screen">
                <div className="carousel-container">
                    <div className="carousel-border-container">
                        <Carousel
                            className="carousel-carouel"
                            showIndicators={false}
                            swipeable={true}
                            showThumbs={false}
                            showArrows={false}
                            showStatus={false}
                            infiniteLoop={true}
                            dynamicHeight={true}
                            autoPlay={true}
                        >
                            <div>
                                <img alt="Jenni & Patrick 1" src={carousel3} />
                            </div>
                            <div>
                                <img alt="Jenni & Patrick 2" src={carousel4} />
                            </div>
                            <div>
                                <img alt="Jenni & Patrick 3" src={carousel5} />
                            </div>
                            <div>
                                <img alt="Jenni & Patrick 3" src={carousel6} />
                            </div>
                            <div>
                                <img alt="Jenni & Patrick 3" src={carousel7} />
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        );
    }
}
